import React from 'react';
import { Box } from '@quillbot/design-system';

interface StarRatingProps {
  rating: number;
  //   total: number;
  size: number;
}

function StarRating(props: StarRatingProps) {
  const { rating, size = 13 } = props;
  const roundedRating = Math.floor(rating);
  const showHalfRating = rating !== roundedRating;

  return (
    <Box display="flex" alignItems="center">
      {Array(roundedRating)
        .fill('')
        .map((value, idx) => (
          <svg
            key={`rating-${idx}`}
            viewBox="0 0 13 13"
            width={size}
            height={size}
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.686 5.126H8.152L6.746.672 5.341 5.126H.807l3.662 2.748-1.386 4.434L6.746 9.56l3.663 2.748-1.406-4.454 3.683-2.728Z"
              fill="#FFCE31"
            />
          </svg>
        ))}
      {showHalfRating && (
        <svg
          key={`half-rating`}
          viewBox="0 0 13 13"
          width={size}
          height={size}
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.358 5.126H7.824L6.418.672 5.012 5.126H.48L4.14 7.874l-1.386 4.434L6.418 9.56l3.663 2.748-1.406-4.454 3.683-2.728Z"
            fill="url(#a)"
          />
          <defs>
            <linearGradient id="a" x1=".677" y1="5.186" x2="11.962" y2="5.186" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFCE31" />
              <stop offset=".526" stop-color="#FFCE31" stop-opacity=".349" />
              <stop offset="1" stop-color="#FFCE31" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </Box>
  );
}
export default StarRating;
